import { render, staticRenderFns } from "./ChangeTeamModal.vue?vue&type=template&id=32202c88&"
import script from "./ChangeTeamModal.vue?vue&type=script&lang=js&"
export * from "./ChangeTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports